import React, { useState } from "react";
import "./KarishyeSamagiri.scss";

const imgCaretDown = "/assets/images/caret-down.svg";
const imgRupeeIcon = "/assets/images/rupee-icon.svg";

const KarishyeSamagiri = ({ samagiriData = [] }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const karishyeSamagiriItems = samagiriData.filter(
    (item) => item.isProvidedBy === "karishye"
  );

  const totalAmount = karishyeSamagiriItems.reduce((total, item) => {
    return total + (item.samagri?.customerMrp * item.qty || 0);
  }, 0);

  const formatQuantity = (qty, units) => {
    if (units === "gms" || units === "ml") {
      return `${qty} ${units}`;
    } else if (units === "kgs") {
      return `${qty} ${units}`;
    } else {
      return `${qty}`;
    }
  };

  return (
    <div className="karishye-samagiri-container" data-node-id="8946:331">
      <div className="karishye-samagiri-content sm:tw-p-[24px]">
        <div className="karishye-samagiri-header" data-node-id="8946:332">
          <div className="karishye-samagiri-title" data-node-id="8946:333">
            <p>
              Samagiri provided by Karishye{" "}
              <span className="price-mobile-hidden">
                (₹{totalAmount.toFixed(2)})
              </span>
            </p>
          </div>
          <div
            className="karishye-samagiri-toggle"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <div className={`caret-icon ${isExpanded ? "expanded" : ""}`}>
              <img alt="" src={imgCaretDown} />
            </div>
          </div>
        </div>

        {isExpanded && (
          <div
            className="karishye-samagiri-table"
            data-name="Samagri Table listing"
            data-node-id="8946:337"
          >
            <div className="table-header" data-node-id="8946:338">
              <div className="header-border" />
              <div className="header-content">
                <div className="description-header" data-node-id="8946:339">
                  <div className="header-text" data-node-id="8946:340">
                    <p>Item Description</p>
                  </div>
                </div>
                <div className="quantity-header" data-node-id="8946:341">
                  <div className="header-text" data-node-id="8946:342">
                    <p>Quantity</p>
                  </div>
                </div>
                <div className="amount-header" data-node-id="8946:343">
                  <div className="header-text" data-node-id="8946:344">
                    <p>Amount</p>
                  </div>
                </div>
              </div>
            </div>

            {karishyeSamagiriItems.length > 0 ? (
              karishyeSamagiriItems.map((item, index) => (
                <div
                  key={item.id}
                  className="table-row"
                  data-node-id={`8946:${345 + index}`}
                >
                  <div
                    className={`row-border ${
                      index === karishyeSamagiriItems.length - 1
                        ? "last-row"
                        : ""
                    }`}
                  />
                  <div className="row-content">
                    <div className="description-cell">
                      <div className="item-text">
                        <p>{item.samagri?.name || "N/A"}</p>
                      </div>
                    </div>
                    <div className="quantity-cell">
                      <div className="quantity-text">
                        <p>
                          {formatQuantity(item.qty, item.samagri?.units)} @ ₹
                          {item.samagri?.customerMrp || 0}
                        </p>
                      </div>
                    </div>
                    <div className="amount-cell">
                      <div className="amount-text">
                        <p>
                          ₹
                          {(item.samagri?.customerMrp * item.qty || 0).toFixed(
                            2
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="table-row">
                <div className="row-border last-row" />
                <div className="row-content">
                  <div className="description-cell">
                    <div className="item-text">
                      <p>No items provided by Karishye</p>
                    </div>
                  </div>
                  <div className="quantity-cell">
                    <div className="quantity-text">
                      <p>-</p>
                    </div>
                  </div>
                  <div className="amount-cell">
                    <div className="amount-text">
                      <p>₹0.00</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Total Row */}
            <div className="total-row" data-node-id="8946:415">
              <div className="total-content">
                <div className="total-label" data-node-id="8946:416">
                  <div className="total-text" data-node-id="8946:417">
                    <p>Total Amount</p>
                  </div>
                </div>
                <div className="total-amount-row" data-node-id="8946:418">
                  <div className="rupee-icon" data-node-id="8946:419">
                    <img alt="" src={imgRupeeIcon} />
                  </div>
                  <div className="total-value" data-node-id="8946:423">
                    <p>{totalAmount.toFixed(2)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="container-border" />
    </div>
  );
};

export default KarishyeSamagiri;
